import {
  ErrorIcon as Error,
  LoadingIcon as LoadingDs,
  Typography
} from "@packages/ds";
import styled from "styled-components";

import Button from "ds/Button";
import InputDs from "ds/Input";
import { dash } from "Libs/theme";

export const Wrapper = styled.div<{ isErrorBorder?: boolean }>`
  color: var(--section-ebony-light-color, var(--ebony-light));
  background: var(--section-snow-background-color, var(--snow));

  padding: 20px 0px 14px 0px;
  margin-top: 8px;
  border-radius: 4px;
  background-image: ${props =>
    props.isErrorBorder
      ? `${dash("var(--theme-critical-600)", "right")}, ${dash("var(--theme-critical-600)", "right")},
    ${dash("var(--theme-critical-600)", "bottom")}, ${dash("var(--theme-critical-600)", "bottom")}`
      : "none"};
  background-position:
    left top,
    left bottom,
    left top,
    right top;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size:
    24px 1px,
    24px 1px,
    1px 24px,
    1px 24px;
`;
export const StatusWrapper = styled.div`
  color: var(--section-ebony-light-color, var(--ebony-light));
  background: var(--section-snow-background-color, var(--snow));

  border-radius: 4px;
  padding: 32px;
  margin-top: 24px;
  .copyable {
    width: 80%;
  }
  a {
    font-size: 15px;
  }
`;

export const DropdownWrapper = styled.div`
  width: 264px;
  .field-environment-parent {
    width: 264px;
  }
  .Select-control {
    border: none;
    background: #f7f7f7 !important;
    padding: 0 10px;
    line-height: 40px;
    height: 40px;
    width: 300px !important;
    max-width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .select-box__control {
    min-height: 38px;
    height: 40px;
    .select-box__value-container {
      height: 40px;
      .select-box__single-value {
        height: 40px;
        line-height: 38px;
      }
    }
  }
  .dropdown > div {
    display: block;
  }
  .highlight {
    bottom: 21px;
  }
`;

export const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typography.BodyText)`
  padding-bottom: 9px;
  font-weight: 600;
`;

export const ConfigureEnvErrorWrapper = styled.div`
  padding: 0px 32px 5px 32px;
`;
export const BodyTextConfigureEnv = styled(Typography.BodyText)`
  margin: 24px 0 24px 0;
  #environment-name-input {
    width: 264px;
  }
`;

export const EnvironmentTitle = styled(Typography.Title)`
  margin-bottom: 80px;
`;

export const IndexingWrapper = styled.div`
  display: flex;
`;

export const HttpsBodyText = styled(Typography.BodyText)`
  margin-left: 28px;
`;
export const ActivateButton = styled(Button)`
  margin-bottom: 32px;
`;
export const StatusSettingBodyText = styled(Typography.BodyText)`
  margin: 34px 0 8px 0;
  color: var(--section-slate-color, var(--slate));
  a {
    font-size: 15px;
  }
`;

export const EmailSettingsWrapper = styled.div`
  margin-top: 34px;
`;

export const TypeWrapper = styled.div`
  @media (max-width: 1260px) {
    margin-top: 15px;
  }
`;

export const Margin = styled.div`
  margin-top: 34px;
`;

export const ErrorIcon = styled(Error)`
  margin-right: 10px;
`;
export const WarningWrapper = styled.div`
  margin-bottom: 16px;
  display: flex;
`;

export const StickerText = styled(Typography.BodyText)`
  font-size: 13px;
`;
export const PausedWrapper = styled(StatusWrapper)`
  padding-bottom: 32px;
`;
export const PausedTitleWrapper = styled(Typography.BodyText)`
  display: flex;
  margin-bottom: 8px;
`;

export const PausedButton = styled(Button)`
  margin-top: 32px;
`;

export const Input = styled(InputDs)`
  & > input {
    min-width: 264px;
    max-width: 100%;
    height: 40px;
  }
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin-top: 50px;
`;
export const ErrorWrapper = styled.div`
  margin-bottom: 24px;
`;
